const findFormValue = (id, agreementData) => {
    if (agreementData.stages == null) return [];
    return [].concat(...agreementData.stages.map((currentStage) => currentStage.data)).find((val) => val.id === id)
        ?.value;
};

export default findFormValue;
